import React from 'react';
import styled from '@emotion/styled';

import { getColor } from './UICommon';

import { QuestionAndAnswerProp } from '../steps/ProductInformationStep';

const Question = styled.div`
  margin-top: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid ${getColor('BLACK_10')};
`;

const H4 = styled.h4`
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  margin-bottom: 8px;
  color: ${getColor('BLACK')};
`;

const P = styled.p`
  color: ${getColor('BLACK_80')};
`;

export const QuestionAndAnswer = ({ questionAndAnswer }: { questionAndAnswer: QuestionAndAnswerProp }) => {
  const { question, answer } = questionAndAnswer;

  return (
    <Question key={question}>
      <H4>{question}</H4>
      <P>{answer}</P>
    </Question>
  );
};
